import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const MicOnFilled: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg
    width={24}
    height={24}
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <Path
      d='M18.25 11a.75.75 0 01.743.648l.007.102v.5a6.75 6.75 0 01-6.249 6.732l-.001 2.268a.75.75 0 01-1.493.102l-.007-.102v-2.268a6.75 6.75 0 01-6.246-6.496L5 12.25v-.5a.75.75 0 011.493-.102l.007.102v.5a5.25 5.25 0 005.034 5.246l.216.004h.5a5.25 5.25 0 005.246-5.034l.004-.216v-.5a.75.75 0 01.75-.75zM12 2a4 4 0 014 4v6a4 4 0 01-8 0V6a4 4 0 014-4z'
      fill={fillColor}
    />
  </Svg>
)
export default MicOnFilled
